import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import { LoaderService } from '../../loader.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  isLoginError = false;
  username: string;
  password: string;
  scaptchaResponse: string;
  recaptchaStr = '';

  constructor(private userService: UserService,
              private router: Router,
              private loaderService: LoaderService) { }

  ngOnInit() {
  }

  onLoginSubmit(): void {
      this.login();
      }

  resolved(captchaResponse: string): void {
          this.recaptchaStr = captchaResponse;
          if (this.recaptchaStr) {
              this.onLoginSubmit();
          }
      }
  onLoginClick(captchaRef: any): void {
        if (this.recaptchaStr) {
            captchaRef.reset();
        }
        captchaRef.execute();
    }
  login() {
     // console.log('Despues del exe');
      // https://www.collegestash.com/invisible-recaptcha-with-angular-5/
      this.loaderService.display(true);
     this.userService.userAuthentication(this.username, this.password, this.recaptchaStr).subscribe((data: any) => {
      // console.log(data);
      localStorage.setItem('userToken', data.access_token);
      sessionStorage.removeItem('currClient');
      // this.navegacionServices.currentClient = null;
      this.router.navigate(['/dashboard']);
    },
    (err: HttpErrorResponse) => {
      // console.log(err);
      this.isLoginError = true;
    });
    this.loaderService.display(false);
  }



}



// WEBPACK FOOTER //
// ./src/app/user/sign-in/sign-in.component.ts